import React, {useEffect, useState} from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import Skills from "./skills/Skills";
import WorkExperience from "./workExperience/WorkExperience";
import Footer from "../components/footer/Footer";
import Education from "./education/Education";
import ScrollToTopButton from "./topbutton/Top";
import Profile from "./profile/Profile";
import SplashScreen from "./splashScreen/SplashScreen";
import PrivacyPolicy from "../components/privacyPolicy/PrivacyPolicy";
import {splashScreen} from "../portfolio";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";
import "./Main.scss";
import UdemyCourses from "./udemy/UdemyCourses";

const Main = () => {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(
    window.location.hash === "#privacy-policy"
  );

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  useEffect(() => {
    const syncPrivacyView = () => {
      const isPrivacyPage = window.location.hash === "#privacy-policy";
      setShowPrivacyPolicy(isPrivacyPage);
      if (isPrivacyPage) {
        window.scrollTo({top: 0, behavior: "smooth"});
      }
    };

    syncPrivacyView();
    window.addEventListener("hashchange", syncPrivacyView);

    return () => {
      window.removeEventListener("hashchange", syncPrivacyView);
    };
  }, []);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : showPrivacyPolicy ? (
          <>
            <Header />
            <PrivacyPolicy />
            <Footer />
            <ScrollToTopButton />
          </>
        ) : (
          <>
            <Header />
            <Greeting />
            <Skills />
            <Education />
            <WorkExperience />
            <UdemyCourses />
            <Profile />
            <Footer />
            <ScrollToTopButton />
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default Main;
